import { IconProps } from "../../utils/global-types/global-types";

const VerbamailIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-6 h-6"}
      {...rest}
    >
      <path
        fill="currentColor"
        d="M12.75 2.625h-7.5C3 2.625 1.5 3.75 1.5 6.375v5.25c0 2.625 1.5 3.75 3.75 3.75h7.5c2.25 0 3.75-1.125 3.75-3.75v-5.25c0-2.625-1.5-3.75-3.75-3.75m.352 4.568-2.347 1.875C10.26 9.465 9.63 9.66 9 9.66s-1.267-.195-1.755-.592L4.898 7.193a.577.577 0 0 1-.09-.795.56.56 0 0 1 .787-.09l2.348 1.874c.57.458 1.537.458 2.107 0l2.348-1.875c.24-.195.6-.157.787.09.195.24.157.6-.083.795"
      ></path>
    </svg>
  );
};

export default VerbamailIcon;
